import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a49e7572"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade modal-md",
  tabindex: "-1",
  id: "modalChat",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = {
  class: "modal-content",
  style: {"position":"relative"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-header d-flex justify-content-between align-items-center p-3",
  style: {"border-top":"4px solid #F64E60"}
}, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title mb-0",
    id: "staticBackdropLabel"
  }, "Chat"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = {
  class: "modal-body d-flex flex-column-reverse",
  ref: "containerChat",
  "data-mdb-perfect-scrollbar-init": "",
  style: {"position":"relative","height":"400px","overflow":"auto","background-color":"#e8e8e8","padding-bottom":"0"}
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"100%","background-color":"#e8e8e8"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "subtitulo",
  style: {"text-align":"center"}
}, "Este chat será habilitado assim que o cliente enviar a primeira mensagem.", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = { class: "small mb-1" }
const _hoisted_11 = { class: "small mb-1 text-muted" }
const _hoisted_12 = { class: "d-flex flex-row justify-content-start gap-2 mb-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava5-bg.webp",
  alt: "avatar 1",
  style: {"width":"45px","height":"100%"}
}, null, -1))
const _hoisted_14 = {
  class: "d-flex flex-column",
  style: {"background-color":"#ffffff","padding":"0.2rem","align-self":"end","border-radius":"0px 15px 15px 15px"}
}
const _hoisted_15 = { class: "small p-2 rounded-3 bg-body-tertiary" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-between"
}
const _hoisted_17 = { class: "small mb-1 text-muted" }
const _hoisted_18 = { class: "small mb-1" }
const _hoisted_19 = { class: "d-flex flex-row justify-content-end mb-4 pt-1 gap-2" }
const _hoisted_20 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_21 = {
  class: "d-flex flex-column mb-2",
  style: {"background-color":"#D1D8E3","max-width":"60%","padding":"0.2rem","align-self":"end","border-radius":"15px 0px 15px 15px"}
}
const _hoisted_22 = { class: "p-1 small" }
const _hoisted_23 = {
  key: 0,
  class: "rounded-3 mb-2 d-flex flex-column",
  style: {"background-color":"#D1D8E3","max-width":"60%","padding":"0.2rem","align-self":"end"}
}
const _hoisted_24 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_25 = {
  class: "d-flex flex-column",
  style: {"background-color":"#D1D8E3","padding":"0.2rem","align-self":"end","border-radius":"15px 0px 15px 15px"}
}
const _hoisted_26 = { class: "p-1 small" }
const _hoisted_27 = {
  key: 2,
  src: "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava6-bg.webp",
  alt: "avatar 1",
  style: {"width":"45px","height":"100%"}
}
const _hoisted_28 = { class: "modal-footer text-muted d-flex justify-content-start align-items-center p-3" }
const _hoisted_29 = { class: "input-group mb-0" }
const _hoisted_30 = { class: "container-input d-flex flex-column w-100" }
const _hoisted_31 = {
  key: 0,
  class: "d-flex flex-row card-anexo-container w-100",
  style: {"overflow":"auto"}
}
const _hoisted_32 = { class: "fs-10" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20 5.625V16.875C20 17.9102 19.1602 18.75 18.125 18.75H1.875C0.839844 18.75 0 17.9102 0 16.875V5.625C0 4.58984 0.839844 3.75 1.875 3.75H5.3125L5.79297 2.46484C6.06641 1.73437 6.76562 1.25 7.54688 1.25H12.4492C13.2305 1.25 13.9297 1.73437 14.2031 2.46484L14.6875 3.75H18.125C19.1602 3.75 20 4.58984 20 5.625ZM14.6875 11.25C14.6875 8.66406 12.5859 6.5625 10 6.5625C7.41406 6.5625 5.3125 8.66406 5.3125 11.25C5.3125 13.8359 7.41406 15.9375 10 15.9375C12.5859 15.9375 14.6875 13.8359 14.6875 11.25ZM13.4375 11.25C13.4375 13.1445 11.8945 14.6875 10 14.6875C8.10547 14.6875 6.5625 13.1445 6.5625 11.25C6.5625 9.35547 8.10547 7.8125 10 7.8125C11.8945 7.8125 13.4375 9.35547 13.4375 11.25Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 25 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M23.2444 0.655309L0.612546 13.712C-0.271243 14.2198 -0.158938 15.4502 0.719968 15.8213L5.9104 17.9991L19.9387 5.63578C20.2073 5.39652 20.5881 5.76273 20.3586 6.04105L8.59594 20.3721V24.3028C8.59594 25.4551 9.98755 25.9092 10.6711 25.0743L13.7717 21.2998L19.8557 23.8487C20.5491 24.1416 21.3401 23.7071 21.467 22.96L24.9827 1.86625C25.1487 0.879918 24.0891 0.167028 23.2444 0.655309Z",
    fill: "#ED2B46"
  })
], -1))
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_ctx.chat.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chat, (msg, key) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              (msg.id_cargo == 3)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(msg.username), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatDate(msg.created_at)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(msg.description), 1)
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (msg.description || msg.urls.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.formatDate(msg.created_at)), 1),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(msg.username), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      (msg.urls.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_el_image, {
                                class: "rounded-3",
                                src: msg.urls[0].url,
                                alt: "",
                                style: {"max-width":"100%","height":"auto"},
                                "preview-src-list": msg.urls.map((item) => item.url),
                                "initial-index": 0
                              }, null, 8, ["src", "preview-src-list"]),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(msg.description), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.urls, (url, key) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: key,
                                class: "d-flex flex-column"
                              }, [
                                (key !== 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createVNode(_component_el_image, {
                                        class: "rounded-3",
                                        src: url.url,
                                        alt: "",
                                        style: {"max-width":"100%","height":"auto"},
                                        "preview-src-list": msg.urls.map((item) => item.url),
                                        "initial-index": key
                                      }, null, 8, ["src", "preview-src-list", "initial-index"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (msg.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("span", _hoisted_26, _toDisplayString(msg.description), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64)),
                      (msg.description || msg.urls.length > 0)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
            ]))
          }), 128))
        ], 512),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              (_ctx.uploadedFiles.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedFiles, (file, key) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: key,
                        class: "card-anexo",
                        style: {"padding":"0.3rem"}
                      }, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(file.name), 1),
                        _createElementVNode("div", {
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.removeUrl(_ctx.uploadedFiles, key))
                        }, "X", 8, _hoisted_33)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_34, [
                _withDirectives(_createElementVNode("input", {
                  onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["enter"])),
                  type: "text",
                  class: "input-message p-1 flex-grow-1",
                  placeholder: "Digite uma mensagem",
                  "aria-label": "Recipient's username",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mensagem) = $event)),
                  disabled: _ctx.chat.length === 0
                }, null, 40, _hoisted_35), [
                  [_vModelText, _ctx.mensagem]
                ]),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openInput && _ctx.openInput(...args))),
                  class: "d-flex align-items-center container-svg-picture"
                }, [
                  _hoisted_36,
                  _createElementVNode("input", {
                    type: "file",
                    ref: "fileInputChat",
                    multiple: "",
                    id: "input-card-chat",
                    name: "fileUploadChat",
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filesChange && _ctx.filesChange(...args))),
                    accept: "image/*",
                    disabled: _ctx.chat.length === 0
                  }, null, 40, _hoisted_37)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args))),
                  class: "d-flex align-items-center container-svg-send",
                  disabled: _ctx.chat.length === 0
                }, _hoisted_40, 8, _hoisted_38)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}